module.exports = __webpack_public_path__ + "assets/img/3f7e8295f5b903c155c0222e687f0627.png";